let model = {};

// dữ liệu form
model.dataForm = {
  id: undefined, // optional - Mã tự sinh
  name: undefined, // required, minLength: 1 - Tên nhóm
  socket_ids: [],
};
model.tableRules = {
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 20,
  offset: 0,
  sort: "name",
  defaultSort: ["name", "ascending"],
  fields: "id,name,socket_ids",
  filters: "",
  dataSearch: {
    value: {
      name: "",
    },
    operator: {
      name: ":regex_i:",
    },
  },
};

export default model;
